import { STATS } from "../../data/services";
import Reveal from "../Reveal";

export const TrackRecord = () => {
  return (
    <section
      id="track-record"
      data-testid="track-record-section"
      className="relative z-10 py-24 md:py-32 bg-[#f4f3ee]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
                / Why work with me
              </span>
              <h2 className="mt-5 font-head text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[1.02] text-[#111111]">
                Enterprise-grade skills for large corporations and small teams.
              </h2>
              <p className="mt-6 font-body text-lg text-neutral-600 max-w-md leading-relaxed">
                I&apos;ve spent 13+ years building mission-critical software for
                large corporations, government and healthcare — bringing that
                same craft, care and reliability to every client and team.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-px bg-black/10 border border-black/10">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.05}>
                  <div className="bg-white p-8 md:p-10 h-full">
                    <p className="font-head text-4xl md:text-6xl font-extrabold text-[#2f4bff] tracking-tight">
                      {s.value}
                    </p>
                    <p className="mt-3 font-mono-tech text-xs uppercase tracking-[0.15em] text-neutral-500">
                      {s.label}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;
